import axios from "axios";

export const getDevicesCoordinatesAPI = async params => {
  let response = await axios({
    url: `/api/v2/devices/coordinates`,
    method: "GET",
    params
  });

  const devicesCoordinates = response.data.devices;

  return devicesCoordinates;
};
